// extracted by mini-css-extract-plugin
export var bottomSpacing = "EmotionalHeroBannerContent-module--bottom-spacing--68d9a";
export var content = "EmotionalHeroBannerContent-module--content--fb9ba";
export var ctas = "EmotionalHeroBannerContent-module--ctas--e57c0";
export var extraChildren = "EmotionalHeroBannerContent-module--extra-children--6cd1d";
export var title = "EmotionalHeroBannerContent-module--title--38edd";
export var wrapper = "EmotionalHeroBannerContent-module--wrapper--891e1";